import React from "react";

const styles = {
  container: { padding: "16px 12px" },
  heading: {
    fontWeight: 800,
    fontFamily: "Calibri Light",
    fontSize: "16px",
    margin: "8px 0 12px",
  },
  headingMT: { marginTop: 28 },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    columnGap: 10,
    marginBottom: 14,
  },
  cell: {
    fontFamily: "Calibri Light",
    fontSize: "16px",
    minWidth: 0,
    border: "1px solid black",
    color: "black",
    padding: "16px 18px",
    borderRadius: 3,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  center: { textAlign: "center" },
};

const UserAppInviteList = ({
  inviters = [],
  invitees = [],
  onGenerateCode,
  submitting = false,
  disableClick = false,
  disabledReason = "",
}) => {
  const Row = ({ item }) => (
    <div style={styles.row}>
      <div style={styles.cell}>{item.name}</div>
      <div style={{ ...styles.cell, ...styles.center }} className="text-center">
        {item.code}
      </div>
      <div style={{ ...styles.cell, ...styles.center }} className="text-center">
        {item.status}
      </div>
    </div>
  );

  const btnLabel = submitting
    ? "GENERATING..."
    : disabledReason || "GENERATE INVITE CODE";

  return (
    <div style={styles.container}>
      {inviters.length > 0 && (
        <>
          <h6 style={styles.heading}>INVITERS</h6>
          {inviters.map((i) => (
            <Row key={`inviter-${i.id}`} item={i} />
          ))}
        </>
      )}

      {invitees.length > 0 && (
        <>
          <h6 style={{ ...styles.heading, ...styles.headingMT }}>INVITEES</h6>
          {invitees.map((i) => (
            <Row key={`invitee-${i.id}`} item={i} />
          ))}
        </>
      )}

      <div className="d-flex justify-content-end mt-3">
        <button
          type="button"
          onClick={onGenerateCode}
          disabled={submitting || disableClick}
          title={disabledReason || "Generate invite code"}
        >
          {btnLabel}
        </button>
      </div>
    </div>
  );
};

export default UserAppInviteList;
